var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business-cooperation-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu5-4'),"subtitle":"BUSINESS COOPERATION"}}),_c('div',{staticClass:"layout-width layput-ej",attrs:{"id":"articlec"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }